import { AdminUsersRole } from 'stores/users/types';

export const availableRoles: AdminUsersRole[] = ['super-admin', 'admin'];
